"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var React = tslib_1.__importStar(require("react"));
var useHoustonTheme_1 = tslib_1.__importDefault(require("@eduzz/houston-styles/useHoustonTheme"));
var __1 = tslib_1.__importDefault(require(".."));
var useMediaQuery_1 = tslib_1.__importDefault(require("../../hooks/useMediaQuery"));
var defaultSizesMap = {
    lg: 'lg',
    sm: 'md'
};
var mobileSizesMap = {
    lg: 'md',
    sm: 'sm'
};
var Subtitle = React.forwardRef(function (_a, ref) {
    var _b = _a.as, as = _b === void 0 ? 'h2' : _b, children = _a.children, _c = _a.size, sizeProp = _c === void 0 ? 'lg' : _c, props = tslib_1.__rest(_a, ["as", "children", "size"]);
    var breakpoints = (0, useHoustonTheme_1.default)().breakpoints;
    var isMobile = (0, useMediaQuery_1.default)(breakpoints.down('sm'));
    var sizesMap = isMobile ? mobileSizesMap : defaultSizesMap;
    var fontSize = sizesMap[sizeProp];
    return ((0, jsx_runtime_1.jsx)(__1.default, tslib_1.__assign({ as: as, ref: ref, size: fontSize }, props, { children: children })));
});
/**
 * @deprecated Use Typography from Antd
 * https://ant.design/components/typography/
 */
exports.default = Subtitle;
